import { Rental } from '../../core/models';

export const rentalsMock: Rental[] = [
  {
    id: 1,
    name: 'Beautiful Apartment in City Center',
    unit_number: 'Apt 101',
    description:
      'This modern apartment is located in the heart of the city, offering easy access to shopping, dining, and ' +
      'entertainment venues. The space boasts an open layout with large windows that let in plenty of natural light. ' +
      'Enjoy evenings on your private balcony with stunning city views. The kitchen is fully equipped with stainless ' +
      'steel appliances and granite countertops. Ideal for anyone looking to live in a vibrant urban environment.',
    rent: 2800,
    deposit: 2800,
    available_date: '2024-10-15',
    amenities: ['Pool', 'Gym', 'Parking', 'Rooftop Deck', '24-Hour Security'],
    property: {
      id: 1,
      name: 'City Center Apartments',
      property_type: 'Apartment',
      latitude: '42.461',
      longitude: '-71.164',
      units_count: {
        total: 10,
        residential: 8,
        commercial: 2,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Main St',
        zipcode: '02110',
        country: 'USA',
        display: '123 Main St, Boston, MA 02110',
        neighborhood: 'Downtown',
        primary_number: '123',
      },
    },
    images: [
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 2,
    bathrooms: 1,
    square_feet: 850,
  },
  {
    id: 2,
    name: 'Cozy Studio Near the Park',
    unit_number: 'Unit 3',
    description:
      'This charming studio is nestled in a quiet area just steps away from a beautiful park. The apartment features ' +
      'an open living space with a comfortable sleeping area. Large windows allow natural light to fill the room, ' +
      'creating a bright and airy atmosphere. The kitchen has been recently updated with new appliances, making it ' +
      'perfect for cooking at home. Ideal for anyone who enjoys peaceful surroundings but wants to stay close to the city.',
    rent: 1600,
    deposit: 1600,
    available_date: '2024-11-01',
    amenities: ['Parking', 'Pet Friendly', 'In-Unit Laundry', 'Stainless Steel Appliances', 'Outdoor Space'],
    property: {
      id: 2,
      name: 'Elm Street Studios',
      property_type: 'Studio',
      latitude: '42.362',
      longitude: '-71.065',
      units_count: {
        total: 5,
        residential: 3,
        commercial: 0,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Elm St',
        zipcode: '02110',
        country: 'USA',
        display: '456 Elm St, Boston, MA 02110',
        neighborhood: 'West End',
        primary_number: '456',
      },
    },
    images: [
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 1,
    bathrooms: 1,
    square_feet: 600,
  },
  {
    id: 3,
    name: 'Spacious Loft in Seaport',
    unit_number: 'Unit 5',
    description:
      'This spacious loft offers a unique open-concept layout with high ceilings and exposed brick walls. Located in ' +
      'the heart of the Seaport district, it provides stunning views of the city skyline. The modern kitchen features ' +
      'high-end appliances and a large island, perfect for entertaining guests. The loft also includes a private rooftop ' +
      'deck where you can relax and enjoy the views. With ample storage space and easy access to local attractions, this ' +
      'loft is a rare find.',
    rent: 3200,
    deposit: 3200,
    available_date: '2024-12-01',
    amenities: ['Gym', 'Roof Deck', 'Concierge Service', 'Elevator', '24-Hour Security'],
    property: {
      id: 3,
      name: 'Seaport Lofts',
      property_type: 'Loft',
      latitude: '42.354',
      longitude: '-71.049',
      units_count: {
        total: 20,
        residential: 18,
        commercial: 2,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Seaport Blvd',
        zipcode: '02210',
        country: 'USA',
        display: '789 Seaport Blvd, Boston, MA 02210',
        neighborhood: 'Seaport',
        primary_number: '789',
      },
    },
    images: [
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 1,
    bathrooms: 1,
    square_feet: 950,
  },
  {
    id: 4,
    name: 'Modern Condo in Back Bay',
    unit_number: 'Unit 2B',
    description:
      'Located in the prestigious Back Bay area, this modern two-bedroom condo offers luxury living at its finest. ' +
      'The condo features floor-to-ceiling windows that provide spectacular views of the neighborhood. The master suite ' +
      'includes a walk-in closet and a spa-like bathroom. Enjoy access to the building’s fitness center and swimming pool. ' +
      'This is a perfect home for those looking for style, convenience, and privacy in the heart of Boston.',
    rent: 4000,
    deposit: 4000,
    available_date: '2024-10-20',
    amenities: ['Pool', 'Parking', 'Gym', 'Elevator', 'Private Balcony'],
    property: {
      id: 4,
      name: 'Back Bay Condos',
      property_type: 'Condo',
      latitude: '42.350',
      longitude: '-71.081',
      units_count: {
        total: 30,
        residential: 30,
        commercial: 0,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Commonwealth Ave',
        zipcode: '02115',
        country: 'USA',
        display: '987 Commonwealth Ave, Boston, MA 02115',
        neighborhood: 'Back Bay',
        primary_number: '987',
      },
    },
    images: [
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 2,
    bathrooms: 2,
    square_feet: 1100,
  },
  {
    id: 5,
    name: 'Luxury Penthouse in South End',
    unit_number: 'Unit 12',
    description:
      'This luxury penthouse offers unparalleled panoramic views of the South End. The expansive living room opens onto ' +
      'a private terrace where you can enjoy the sunset. The kitchen is equipped with top-of-the-line appliances and ' +
      'granite countertops. The master bedroom has a spacious walk-in closet and an ensuite bathroom with marble ' +
      'finishes. This exclusive residence is perfect for those seeking both luxury and convenience in Boston.',
    rent: 5200,
    deposit: 5200,
    available_date: '2024-11-05',
    amenities: ['Roof Deck', 'Gym', 'Concierge', 'Parking', 'Private Terrace'],
    property: {
      id: 5,
      name: 'South End Penthouses',
      property_type: 'Penthouse',
      latitude: '42.338',
      longitude: '-71.072',
      units_count: {
        total: 12,
        residential: 12,
        commercial: 0,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Tremont St',
        zipcode: '02118',
        country: 'USA',
        display: '321 Tremont St, Boston, MA 02118',
        neighborhood: 'South End',
        primary_number: '321',
      },
    },
    images: [
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 3,
    bathrooms: 2,
    square_feet: 1400,
  },
  {
    id: 6,
    name: 'Charming Brownstone in Beacon Hill',
    unit_number: 'Unit 3',
    description:
      'This charming brownstone in the heart of Beacon Hill offers the perfect blend of historic charm ' +
      'and modern convenience. Featuring original hardwood floors, crown molding, and an elegant fireplace, the ' +
      'home boasts large, sunlit rooms and high ceilings. The kitchen has been updated with modern appliances, ' +
      'while the bathrooms retain their classic appeal with vintage fixtures. Located on a quiet, tree-lined street, ' +
      "you'll be just steps away from local shops, cafes, and the beautiful Boston Common. Ideal for those seeking a " +
      'quintessential Boston living experience.',
    rent: 3800,
    deposit: 3800,
    available_date: '2024-11-15',
    amenities: [
      'On-Site Parking Available for Rent',
      'Stainless Steel Appliances',
      'In-Unit Laundry',
      'Pet Friendly',
      'Fireplace',
    ],
    property: {
      id: 6,
      name: 'Beacon Hill Brownstones',
      property_type: 'Brownstone',
      latitude: '42.359',
      longitude: '-71.070',
      units_count: {
        total: 8,
        residential: 8,
        commercial: 0,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Charles St',
        zipcode: '02114',
        country: 'USA',
        display: '654 Charles St, Boston, MA 02114',
        neighborhood: 'Beacon Hill',
        primary_number: '654',
      },
    },
    images: [
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 2,
    bathrooms: 1,
    square_feet: 1000,
  },
  {
    id: 7,
    name: 'Sunny Apartment in Fenway',
    unit_number: 'Unit 8',
    description:
      'This sunny apartment is located in the bustling Fenway neighborhood, just steps away from Fenway Park. The ' +
      'apartment features a large living area with plenty of natural light. The kitchen is fully equipped with modern ' +
      'appliances, and the bathroom has been recently renovated. Enjoy easy access to public transportation and local ' +
      'restaurants and shops. This is a perfect spot for anyone looking to enjoy the energy of Fenway.',
    rent: 2700,
    deposit: 2700,
    available_date: '2024-10-30',
    amenities: ['Gym', 'Parking', 'Elevator', '24-Hour Security', 'Laundry in Building'],
    property: {
      id: 7,
      name: 'Fenway Park Apartments',
      property_type: 'Apartment',
      latitude: '42.347',
      longitude: '-71.097',
      units_count: {
        total: 15,
        residential: 12,
        commercial: 3,
      },
      address: {
        city: 'Boston',
        state: 'MA',
        street: 'Boylston St',
        zipcode: '02115',
        country: 'USA',
        display: '222 Boylston St, Boston, MA 02115',
        neighborhood: 'Fenway',
        primary_number: '222',
      },
    },
    images: [
      'https://picsum.photos/id/9/200/300',
      'https://picsum.photos/id/6/800/500',
      'https://picsum.photos/id/8/200/300',
      'https://picsum.photos/id/7/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
      'https://picsum.photos/id/10/200/300',
      'https://picsum.photos/id/11/200/300',
    ],
    bedrooms: 1,
    bathrooms: 1,
    square_feet: 750,
  },
];
